exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".fisdom-table{width:100%;border-spacing:0}.fisdom-table thead td{border-bottom:1px solid rgba(110,110,110,.05);text-transform:capitalize;color:rgba(0,0,0,.6)}.fisdom-table tbody tr:nth-child(1) td{border-top:none}.fisdom-table tbody td{border-top:1px solid rgba(110,110,110,.05)}.fisdom-table td{padding:20px 10px;border-collapse:collapse;font-weight:normal;font-size:15px}", ""]);

// exports
